export const GROWTH_SCHEMA_META = {
  eyebrow: 'SEO · Structured Data',
  titleLead: 'Schema',
  titleAccent: 'manager',
  description:
    'Structured data tells Google what your business is and powers rich search results — stars, FAQs, hours, services. ELVA deploys and maintains all your schema automatically through a one-time script install.',
  snippetUrl: 'smilecentraldental.com › services › implants',
  snippetTitle: 'Dental Implants in NYC — Smile Central Dental',
  snippetRating: '4.7',
  snippetReviews: '185 reviews',
  snippetLocation: 'Dentist in New York, NY',
  snippetDescription:
    'Expert dental implant specialists in Manhattan. Same-day implants, All-on-4, and full-arch restoration. Led by Dr. Maria Martinez, DDS with 18+ years experience…',
  snippetPowersNote:
    'What powers this: Stars from AggregateRating · FAQ dropdown from FAQPage · address & category from LocalBusiness · breadcrumb from BreadcrumbList.',
  howItWorksNote:
    "How ELVA schema injection works: Your webmaster installs a single <script> tag once. That script calls ELVA's API on each page load and injects the correct schema for that page. Update your hours in the PMS and we update the schema; a new GBP review lands and we update the rating — no developer needed for ongoing changes.",
} as const;
